// Cave84 — usePrivacy hook
// Thin, ergonomic wrapper around privacy.store so components don't import
// the Zustand store directly (matches the useAuth / useAuthStore split).
//
// Usage: const { hidden, reveal, conceal, toggle } = usePrivacy();

import { usePrivacyStore } from '@/stores/privacy.store';

export interface UsePrivacyResult {
  hidden: boolean;
  reveal: () => void;
  conceal: () => void;
  toggle: () => void;
}

export function usePrivacy(): UsePrivacyResult {
  const hidden = usePrivacyStore((s) => s.hidden);
  const reveal = usePrivacyStore((s) => s.reveal);
  const conceal = usePrivacyStore((s) => s.conceal);
  const toggle = usePrivacyStore((s) => s.toggle);
  return { hidden, reveal, conceal, toggle };
}
